<template>
  <div class="lc-dropdown" ref="popup">

    <div class="lc-dropdown__section-title">{{ $t('language_menu.choose_language') }}</div>
    <div class="lc-dropdown__grid">
      <div
        v-for="lang in languages"
        :key="lang.code"
        class="lc-dropdown__option"
        :class="{ 'lc-dropdown__option--active': currentLanguage === lang.code }"
        @click="setLanguage(lang.code)"
      >
        {{ lang.label }}
      </div>
    </div>

    <hr class="lc-dropdown__divider" />

    <div class="lc-dropdown__section-title">{{ $t('language_menu.choose_currency') }}</div>
    <div class="lc-dropdown__grid">
      <div
        v-for="curr in currencies"
        :key="curr.code"
        class="lc-dropdown__option"
        :class="{ 'lc-dropdown__option--active': currentCurrency === curr.code }"
        @click="setCurrency(curr.code)"
      >
        {{ curr.label }}
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'LanguageMenu',
  data () {
    return {
      languages: [
        { code: 'fr', label: 'Français' },
        { code: 'en', label: 'English' },
        { code: 'de', label: 'Deutsch' },
        { code: 'es', label: 'Español' },
      ],
      currencies: [
        { code: 'EUR', label: 'Euro (€)' },
        { code: 'USD', label: 'US dollars (USD - $)' },
      ],
    }
  },
  computed: {
    currentLanguage () {
      return this.$i18n.locale
    },
    currentCurrency () {
      return this.$store.state.currency
    }
  },
  mounted () {
    setTimeout(() => {
      document.addEventListener('click', this.handleClickOutside)
    }, 100)
  },
  beforeDestroy () {
    document.removeEventListener('click', this.handleClickOutside)
  },
  methods: {
    handleClickOutside (event) {
      if (this.$refs.popup && !this.$refs.popup.contains(event.target)) {
        this.$emit('close')
      }
    },
    setLanguage (locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
    },
    setCurrency (code) {
      this.$store.commit('setCurrency', code)
    }
  }
}
</script>

<style scoped>
.lc-dropdown {
  position: absolute;
  top: 150%;
  right: 0;
  background-color: white;
  border-radius: 10px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  padding: 16px;
  min-width: 280px;
}

.lc-dropdown__section-title {
  font-size: 0.8rem;
  font-weight: bold;
  color: #222;
  margin-bottom: 10px;
}

.lc-dropdown__grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 6px;
}

.lc-dropdown__option {
  cursor: pointer;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid #e0e0e0;
  font-size: 0.85rem;
  color: rgb(163, 163, 163);
  text-align: center;
  transition: background 0.15s, color 0.15s;
}
.lc-dropdown__option:hover {
  color: black;
  border-color: #bbb;
}
.lc-dropdown__option--active {
  border-color: #222;
  color: black;
  font-weight: bold;
}

.lc-dropdown__divider {
  margin: 14px 0 10px 0;
  border: none;
  border-top: 1px solid rgba(163, 163, 163, 0.3);
}
</style>
